/* Copyright 2013 - 2024 Waiterio LLC */
export default function getInitialContext() {
  return {
    data: {
      restaurants: {},
    },
    language: 'en',
    pages: {
      menu: {},
      restaurant: {},
    },
  }
}
